var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypeOfVariation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.658,
    height: 20.657,
    viewBox: "0 0 20.658 20.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10227",
    "data-name": "Group 10227",
    transform: "translate(0.285 0.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M192.807,71.137a7.541,7.541,0,0,1-.8-.043.335.335,0,0,1,.071-.667,4.65,4.65,0,0,0,3.875-1.108.335.335,0,0,1,.474.474A5.007,5.007,0,0,1,192.807,71.137Z",
    transform: "translate(-176.407 -63.695)",
    fill: "#ee7d11",
    stroke: "#ee7d11",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M69.553,85.944a.335.335,0,0,1-.237-.572c1.27-1.271,1.5-3.42.639-5.9-.887-2.543-.687-4.846.549-6.32a5.273,5.273,0,0,1,5.106-1.518.335.335,0,0,1-.107.662,4.635,4.635,0,0,0-4.485,1.287c-1.08,1.288-1.237,3.354-.429,5.668.952,2.73.661,5.132-.8,6.592A.334.334,0,0,1,69.553,85.944Z",
    transform: "translate(-63.692 -65.822)",
    fill: "#ee7d11",
    stroke: "#ee7d11",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M101.344,14.413a7.859,7.859,0,0,1-1.207-.1.335.335,0,0,1,.1-.663,4.611,4.611,0,0,0,4.445-1.3c1.074-1.289,1.228-3.351.423-5.66-.952-2.73-.661-5.132.8-6.592a.335.335,0,1,1,.474.474c-1.27,1.27-1.5,3.419-.639,5.9.885,2.536.688,4.836-.541,6.31A4.835,4.835,0,0,1,101.344,14.413Z",
    transform: "translate(-91.883 -0.001)",
    fill: "#ee7d11",
    stroke: "#ee7d11",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M.334,160.754a.335.335,0,0,1-.237-.572,5.468,5.468,0,0,1,4.889-1.238.335.335,0,0,1-.108.662,4.825,4.825,0,0,0-4.306,1.05A.334.334,0,0,1,.334,160.754Z",
    transform: "translate(0.001 -146.157)",
    fill: "#ee7d11",
    stroke: "#ee7d11",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M112.365,80.617a.334.334,0,0,1-.237-.1l-4.911-4.912a.335.335,0,0,1,.474-.474l4.912,4.912a.335.335,0,0,1-.237.572Z",
    transform: "translate(-98.567 -69.045)",
    fill: "#ee7d11",
    stroke: "#ee7d11",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M80.279,112.7a.334.334,0,0,1-.237-.1L75.13,107.69a.335.335,0,0,1,.474-.474l4.912,4.912a.335.335,0,0,1-.237.572Z",
    transform: "translate(-69.042 -98.567)",
    fill: "#ee7d11",
    stroke: "#ee7d11",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M168.369,23.564a.334.334,0,0,1-.237-.1l-5.009-5.009a.335.335,0,0,1,.474-.474l5.009,5.009a.335.335,0,0,1-.237.572Z",
    transform: "translate(-150.011 -16.457)",
    fill: "#ee7d11",
    stroke: "#ee7d11",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M19.986,171.948a.334.334,0,0,1-.237-.1l-5.009-5.009a.335.335,0,0,1,.474-.474l5.009,5.009a.335.335,0,0,1-.237.573Z",
    transform: "translate(-13.472 -152.996)",
    fill: "#ee7d11",
    stroke: "#ee7d11",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeOfVariation);
export default __webpack_public_path__ + "static/media/TypeOfVariation.8661ed606795bba86fb38fcd5c93be58.svg";
export { ForwardRef as ReactComponent };